import { useEffect, useState } from 'react'

const isImageUrl = (value) => typeof value === 'string' && /^(https?:)?\/\//i.test(value)

export default function UserAvatar({
  src,
  alt,
  fallback = '🙂',
  imageClassName = '',
  loading = 'eager',
  priority = false
}) {
  const [imgError, setImgError] = useState(false)

  useEffect(() => {
    setImgError(false)
  }, [src])

  const canShowImage = isImageUrl(src) && !imgError

  if (!canShowImage) return fallback

  return (
    <img
      className={imageClassName}
      src={src}
      alt={alt || 'user avatar'}
      loading={loading}
      decoding="async"
      fetchPriority={priority ? 'high' : 'auto'}
      referrerPolicy="no-referrer"
      onError={() => setImgError(true)}
    />
  )
}
